export class LabelsConfig {
  private readonly _apiUrl: string

  constructor() {
    this._apiUrl = "/api/labels"
  }

  public get apiUrl() {
    return this._apiUrl
  }
}
